import instance from "./instance";
import {
  TemplateResponseDto,
  TemplateCreateResponseDto,
  TemplateDetailResponseDto,
  TemplateSelectionDto,
} from "@/dto/TemplatesDto";
import { ENV } from "@/constants/env";
import { ResponseDataDto } from "@/dto/ResponseDto";

// 템플릿 관리 API 경로
const PREFIX_PATH = "admin/templates";

/**
 * 템플릿 목록 조회
 * @param productId 상품 ID
 * @returns 템플릿 목록
 */
export const findAll = async (
  productId?: string
): Promise<TemplateResponseDto> => {
  const params = productId ? { productId } : {};
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}`, { params });
};

/**
 * 템플릿 생성 (멀티파트 폼데이터)
 * @param request 템플릿 생성 요청 DTO
 * @returns 템플릿 생성 응답 DTO
 */
export const create = async (
  request: FormData
): Promise<TemplateCreateResponseDto> => {
  // multipart/form-data로 요청 전송
  return await instance.post(`${ENV.PRE_FIX}/${PREFIX_PATH}`, request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * 템플릿 상세 조회
 * @param id 템플릿 ID
 * @returns 템플릿 상세 정보
 */
export const findById = async (
  id: string
): Promise<TemplateDetailResponseDto> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/${id}`);
};

/**
 * 템플릿 삭제
 * @param id 템플릿 ID
 * @returns 삭제 결과
 */
export const deleteById = async (id: string): Promise<TemplateResponseDto> => {
  return await instance.delete(`${ENV.PRE_FIX}/${PREFIX_PATH}/${id}`);
};

/**
 * 템플릿 수정
 * @param id 템플릿 ID
 * @param request 템플릿 수정 요청 DTO
 * @returns 템플릿 수정 응답 DTO
 */
export const update = async (
  id: string,
  request: FormData
): Promise<TemplateResponseDto> => {
  return await instance.put(`${ENV.PRE_FIX}/${PREFIX_PATH}/${id}`, request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * 템플릿 선택 리스트 조회
 * @returns 템플릿 선택 리스트
 */
export const findAllByTemplate = async (): Promise<
  ResponseDataDto<TemplateSelectionDto[]>
> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/selection`);
};


